import { RadiusValues } from '../../radius/radius/index.js';
import { convertRadiusToCSS } from '../../radius/converters/index.js';
import '../../styleHelpers/scrollbar/types/index.js';
import '../../styleHelpers/scrollbar/skins/index.js';
import '../../styleHelpers/getDeviceType/getDeviceType/index.js';
import '../../styleHelpers/generateTheme/generateTheme/index.js';
import { convertTimingsToCSS } from '../../timings/converters/index.js';
import { TimingValues } from '../../timings/timings/index.js';
import { convertEasingToCSS } from '../../easing/converters/index.js';
import { EasingValues } from '../../easing/easing/index.js';
import { tabFocusStyles } from '../../styleHelpers/tabFocus/tabFocus/index.js';
import { resetters } from '../../styleHelpers/resetters/resetters/index.js';
import '../../styleHelpers/initFavIcons/initFavIcons/index.js';
import '../../fonts/types/index.js';
import { withFontFamily, GilroyFonts } from '../../fonts/fonts/index.js';
import '../../colors/accents/accents/index.js';
import '../../colors/backgrounds/backgrounds/index.js';
import '../../colors/texts/texts/index.js';
import { convertThemeToCSS } from '../../colors/themes/converters/index.js';
import { ThemeLightValues, ThemeDarkValues } from '../../colors/themes/themes/index.js';
import { convertSpacingsToCSS } from '../../spacings/converters/index.js';
import { SpacingsValues } from '../../spacings/spacings/index.js';
import { TypographyValues } from '../../typography/typography/index.js';
import { convertTypographyToCSS } from '../../typography/converters/index.js';

const Foundation = {
    ...withFontFamily(GilroyFonts),
    ...resetters,
    ':root': {
        ...tabFocusStyles,
        ...convertSpacingsToCSS(SpacingsValues),
        ...convertTimingsToCSS(TimingValues),
        ...convertRadiusToCSS(RadiusValues),
        ...convertEasingToCSS(EasingValues),
        ...convertTypographyToCSS(TypographyValues),
    },
    ':root.light': {
        ...convertThemeToCSS(ThemeLightValues),
    },
    ':root.dark': {
        ...convertThemeToCSS(ThemeDarkValues),
    },
};

export { Foundation };
